module.exports = __webpack_public_path__ + "static/img/team-2.7e58fe70.jpg";